import { delay } from 'lodash';


class Poller {
  constructor(options) {
    this.retrieve = options.retrieve;
    this.fence = options.fence;
    this.received = options.received;
    this.position = options.position ?? -1;
    this.events = [];
    this.period = options.perdiod ?? 1000;
  }

  async poll() {
    try {
      // abort if we are no longer polling
      if (!this.polling) return;

      // request events
      const events = await this.retrieve(this.position);

      // if we don't events exit
      if (!Array.isArray(events) || events.length <= 0) return;

      // abandone receive events if they do not pass fence
      if (this.fence && this.fence(events)) {
        return;
      }

      // assign events, they are valid
      this.events = events;

      // update position in stream
      this.position = this.events[this.events.length - 1].ingested;

      // call received handler
      if (this.received) {
        this.received(this.events);
      }
    } catch(error) {
      console.error(error);
    }
    finally {
      delay(() => this.poll(), this.period);
    }
  }
  start() {
    this.polling = true;
    this.poll();
  }
  stop() {
    this.polling = false;
  }
  reset() {
    this.position = -1;
    this.events = [];
  }
}

export default Poller;
